
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9EfQi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::366baf66b1a43ca29896dfea5fa24833>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7064237ec0509524$var$_react = $7064237ec0509524$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7064237ec0509524$var$_iconNew = $7064237ec0509524$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $7064237ec0509524$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/drag-handle-horizontal
 * Usage guidance:
 * Reserved for dragging elements along a horizontal axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7064237ec0509524$var$DragHandleHorizontalIcon = (props)=>/*#__PURE__*/ $7064237ec0509524$var$_react.default.createElement($7064237ec0509524$var$_iconNew.default, Object.assign({
        name: "DragHandleHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 9a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m0-5.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5M8 9a1.75 1.75 0 1 1 0 3.5A1.75 1.75 0 0 1 8 9m0-5.5A1.75 1.75 0 1 1 8 7a1.75 1.75 0 0 1 0-3.5M13.25 9a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m0-5.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"/>`
    }, props));
$7064237ec0509524$var$DragHandleHorizontalIcon.displayName = 'DragHandleHorizontalIcon';
var $7064237ec0509524$var$_default = module.exports.default = $7064237ec0509524$var$DragHandleHorizontalIcon;

});


//# sourceMappingURL=drag-handle-horizontal.5b291132.js.map
